module.exports = __webpack_public_path__ + "img/img1.f2d1b80c.svg";